import { Injectable } from '@angular/core';
import { ZAVER_ICON_DATA } from '../zaver-icons/registry/zaver-icon-data';

export interface Symbols {
  [key: string]: string;
}
@Injectable({
  providedIn: 'root',
})
export class ZaverIconsService {
  private zaverIconData: typeof ZAVER_ICON_DATA = ZAVER_ICON_DATA;
  private parser = new DOMParser();

  constructor() {}

  private tryParseSymbol(key: string, svg: string) {
    const doc = this.parser.parseFromString(svg, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');

    if (doc.querySelector('parsererror')) {
      console.warn(
        `Skipping icon "${key}": SVG contains parse errors. Please doublecheck "${key}" format`,
      );
      return null;
    }

    if (svgElement) {
      const viewBox = svgElement.getAttribute('viewBox');
      const paths = svgElement.innerHTML;

      if (viewBox) {
        return `<symbol id='icon-${key}' viewBox="${viewBox}">${paths}</symbol>`;
      } else {
        return `<symbol id='icon-${key}'>${paths}</symbol>`;
      }
    }
  }

  formatSVGIntoSymbol(): void {
    let symbolCollection: string[] = [];

    for (const [key, svg] of Object.entries(this.zaverIconData)) {
      if (typeof svg === 'string') {
        const symbol = this.tryParseSymbol(key, svg);
        if (symbol) symbolCollection.push(symbol);
      } else if (typeof svg === 'object') {
        for (const [nestedKey, nestedValue] of Object.entries(svg)) {
          const symbol = this.tryParseSymbol(nestedKey, nestedValue);
          if (symbol) symbolCollection.push(symbol);
        }
      }
    }
    const spriteSheet = `
      <svg xmlns="http://www.w3.org/2000/svg" 
        class="zaver-sprite-sheet"
        style="position: absolute; width: 0; height: 0; overflow: hidden;" 
        aria-hidden="true">
        ${symbolCollection.join('\n')}
      </svg>
    `;

    // NOTE: Becuase we are parsing through svg/xml, we need to explicitly define "fill" inside
    // of the SVG. Otherwise the browser will automatically render it black.
    const parsed = this.parser.parseFromString(spriteSheet, 'image/svg+xml');

    if (parsed.querySelector('parsererror')) {
      console.error(
        'Failed to parse the final sprite sheet — no icons will be injected',
      );
      return;
    }

    document.body.append(parsed.documentElement);
  }
}
